import { supportedLocale } from '../components/localeContent';

const DEFAULT_LOCALE = "en_US";

/**
 * Resolves the locale from the URL query parameter.
 * Checks both the raw value (e.g., pt_BR) and the hyphenated format (e.g., pt-BR).
 * Falls back to en_US if no supported locale is found.
 */
export const getLocalePreference = (): string => {
  if (typeof window === 'undefined') {
    return DEFAULT_LOCALE;
  }

  const rawLocale = new URLSearchParams(window.location.search).get('locale');

  if (rawLocale && supportedLocale.indexOf(rawLocale) >= 0) {
    return rawLocale;
  }

  if (rawLocale && supportedLocale.indexOf(rawLocale.replace('-', '_')) >= 0) {
    return rawLocale.replace('-', '_');
  }

  return DEFAULT_LOCALE;
};
